/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Lucas's Portfolio",
  description:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Lucas François Portfolio",
    type: "website",
    // url: "http://ashutoshhathidara.com/",
  },
};

//Home Page
const greeting = {
  title: "Lucas Francois",
  logo_name: "Lucas François",
  nickname: "Azu",
  subTitle: `Passionate about systems architecture and data protection, I’m Lucas, a future Network Administrator specializing in Cybersecurity.

Currently a work-study student at SFR Business, I operate at the heart of La Réunion’s digital infrastructures. My day-to-day work involves ensuring the high availability and security of critical services — from Level 3 (N3) troubleshooting to SD-WAN and VoIP deployment.

My goal: to combine technical rigor with responsiveness in order to build resilient networks.

I invite you to explore this portfolio to discover who I am, my professional approach, and the projects that shape my expertise every day. Welcome to my technical world!`,
  // ... rest of the config

// resumeLink:    "https://drive.google.com/file/d/1bXRknv_h-XI_3CQ3SGPteGODtvEb7YvI/view?usp=sharing",
 portfolio_repository: "https://github.com/Azupic",
  githubProfile: "https://github.com/Azupic",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/Azupic",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/lucas-fran%C3%A7ois-594a20266/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  // {
  //   name: "YouTube",
  //   link: "https://youtube.com/c/DevSense19",
  //   fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
  //   backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  // },
  {
    name: "Gmail",
    link: "mailto:ashutoshhathidara98@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "X-Twitter",
    link: "https://twitter.com/ashutosh_1919",
    fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
  },
  // {
  //   name: "Facebook",
  //   link: "https://www.facebook.com/laymanbrother.19/",
  //   fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
  //   backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  // },
  // {
  //   name: "Instagram",
  //   link: "https://www.instagram.com/layman_brother/",
  //   fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
  //   backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  // },
];

const skills = {
  data: [
    {
      title: "Cybersécurité & Systèmes Sécurisés",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Analyse de vulnérabilités, audits de sécurité et sécurisation des réseaux d’entreprise.",
        "⚡ Mise en place et configuration de pare-feux, VPN, IDS/IPS, et solutions de chiffrement.",
        "⚡ Participation à des CTF (Capture The Flag) et réalisation de tests d’intrusion encadrés.",
        "⚡ Surveillance réseau, filtrage avec iptables et détection de comportements suspects.",
        "⚡ Administration de systèmes Linux et Windows Server avec renforcement de la sécurité.",
        "⚡ Scripting en Python/Bash pour l'automatisation des tâches de sécurité et la création d'outils personnalisés.",
        "⚡ Sensibilisation à la cybersécurité (phishing, ingénierie sociale, politiques de sécurité).",
        "⚡ Utilisation de Kali Linux et d'outils d'analyse comme Nmap, Metasploit, John the Ripper, etc.",
        "⚡ Administration de systèmes Linux (Debian, Ubuntu) et Windows Server, avec gestion des services réseau, des utilisateurs et des permissions.",
        "⚡ Compétences en administration système sur Windows, Linux  et macOS : gestion réseau, sécurité, services et environnements multi-OS.",


      
      
      ],
      softwareSkills: [
        {
          skillName: "Linux",
          fontAwesomeClassname: "simple-icons:linux",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Microsoft",
          fontAwesomeClassname: "simple-icons:microsoft",
          style: {
            backgroundColor: "white",
          },
        },
     
       
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Deeplearning",
          imageSrc: "deeplearning_ai_logo.png",
        },
      ],
    },
    {
      title: "Réseaux et Télécommunications",
      fileName: "Réseaux",
      skills: [
      "⚡ Conception et configuration d’architectures réseaux sécurisées (DMZ, VLANs, routage dynamique : OSPF, BGP, RIP, etc.) sur des équipements Cisco, Aruba, et virtualisés via GNS3 ou VMware.",

"⚡ Implémentation de services réseaux essentiels (DNS, DHCP, NAT) et gestion d’Active Directory pour le contrôle des accès utilisateurs en environnement d’entreprise.",

"⚡ Mise en place de solutions de sécurité réseau : pare-feu (PfSense, Stormshield), segmentation réseau, filtrage, politiques de sécurité et tests de vulnérabilité (pentesting).",

"⚡ Déploiement de réseaux multisites virtualisés, avec configuration de tunnels VPN et infrastructures cloud interconnectées.",

"⚡ Rédaction de documentation technique, schémas d’architecture et rapports d’audit réseau, avec un usage professionnel de LaTeX et des outils Office.",
      ],
      softwareSkills: [
        {
          skillName: "Cisco",
          fontAwesomeClassname: "simple-icons:cisco",
          style: {
            color: "#FF2BC2",
          },
        },
        // {
        //   skillName: "Figma",
        //   fontAwesomeClassname: "simple-icons:user-secret",
        //   style: {
        //     color: "#F24E1E",
        //   },
        // },
        // {
        //   skillName: "Adobe Illustrator",
        //   fontAwesomeClassname: "simple-icons:adobeillustrator",
        //   style: {
        //     color: "#FF7C00",
        //   },
        // },
        // {
        //   skillName: "Inkscape",
        //   fontAwesomeClassname: "simple-icons:inkscape",
        //   style: {
        //     color: "#000000",
        //   },
        // },
      ],
    },



    {
      title: "Developpement",
      fileName: "FullStackImg",
      skills: [
        "⚡ Création de plateformes web interactives avec Flask et Django : développement de dashboards d'administration, d'APIs REST et de systèmes de gestion d'utilisateurs sécurisés, adaptés aux cas d’usage en réseaux et télécoms.",

"⚡ Réalisation de projets intégrés aux systèmes télécoms : portails captifs pour bornes Wi-Fi, interfaces web de gestion réseau, et dashboards de supervision en temps réel, alliant logique réseau et développement web.",

"⚡ Développement d'applications mobiles et web avec Flutter, React Native et des apps Android natives en Kotlin, ainsi que des backends robustes avec Node.js, Express et Flask.",

"⚡ Déploiement complet d’applications full-stack sur serveurs Linux : configuration de Nginx, DNS, SSL, pare-feu et mise en place de solutions sécurisées, mêlant compétences en administration système et développement.",

"⚡ Conception d’interfaces web modernes et responsives avec HTML, CSS, JavaScript et React-Redux, pour une expérience utilisateur fluide et intuitive."
      ],
      softwareSkills: [

        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Django",
          fontAwesomeClassname: "simple-icons:django",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Flask",
          fontAwesomeClassname: "simple-icons:flask",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "PHP",
          fontAwesomeClassname: "simple-icons:php",
          style: {
            color: "#2C8EBB",
          },
        },
        
        
        
       
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
       "⚡ Expérience sur plusieurs plateformes cloud pour le déploiement et la gestion d’applications web et réseau.",

"⚡ Déploiement et maintenance d’infrastructures cloud à l’aide de machines virtuelles, avec intégration de bases de données (PostgreSQL, MongoDB) et configuration réseau avancée.",

"⚡ Maîtrise de Docker pour la conteneurisation des applications, et de Kubernetes pour leur orchestration, la mise à l’échelle automatique (autoscaling) et le déploiement en cluster.",

"⚡ Déploiement de modèles d’intelligence artificielle sur le cloud, exposés via des APIs REST pour des intégrations web ou mobiles.",

"⚡ Sécurisation des architectures cloud via pare-feu, gestion des certificats SSL (Let's Encrypt), proxy inverse (Nginx) et authentification multi-facteurs (MFA).",

      ],
      softwareSkills: [
      
             
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
                
        
        
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
   
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    // {
    //   siteName: "LeetCode",
    //   iconifyClassname: "simple-icons:leetcode",
    //   style: {
    //     color: "#F79F1B",
    //   },
    //   profileLink: "https://leetcode.com/layman_brother/",
    // },
    // {
    //   siteName: "HackerRank",
    //   iconifyClassname: "simple-icons:hackerrank",
    //   style: {
    //     color: "#2EC866",
    //   },
    //   profileLink: "https://www.hackerrank.com/layman_brother",
    // },
    // {
    //   siteName: "Codechef",
    //   iconifyClassname: "simple-icons:codechef",
    //   style: {
    //     color: "#5B4638",
    //   },
    //   profileLink: "https://www.codechef.com/users/ashutosh_1919",
    // },
    // {
    //   siteName: "Codeforces",
    //   iconifyClassname: "simple-icons:codeforces",
    //   style: {
    //     color: "#1F8ACB",
    //   },
    //   profileLink: "http://codeforces.com/profile/layman_brother",
    // },
    // {
    //   siteName: "Hackerearth",
    //   iconifyClassname: "simple-icons:hackerearth",
    //   style: {
    //     color: "#323754",
    //   },
    //   profileLink: "https://www.hackerearth.com/@ashutosh391",
    // },
    // {
    //   siteName: "Kaggle",
    //   iconifyClassname: "simple-icons:kaggle",
    //   style: {
    //     color: "#20BEFF",
    //   },
    //   profileLink: "https://www.kaggle.com/laymanbrother",
    // },
  ],
};

const degrees = {
  degrees: [
    {
      title: "BUT Réseaux et Télécommunions parcours Cybersécurité",
      subtitle: "IUT de Saint-Pierre",
      logo_path: "IUT_rond.png",
      alt_name: "IUT de Saint-Pierre",
      duration: "2022 - 2026",
      descriptions: [
        "⚡ Études approfondies des réseaux informatiques, protocoles de communication (TCP/IP, DNS, DHCP, etc.), et des infrastructures systèmes (Linux, Windows Server).",
        "⚡ Formation spécialisée en cybersécurité : pare-feux, analyse de vulnérabilités, cryptographie, pentesting, sécurisation des systèmes et des réseaux.",
        "⚡ Réalisation de projets pratiques : configuration de réseaux, déploiement de services, mise en place de solutions de sécurité (VPN, IDS/IPS), audits de sécurité.",
        "⚡ Participation à des challenges en cybersécurité (CTF), mise en œuvre de maquettes réseau avec outils comme Wireshark, Cisco Packet Tracer,GNS3 et VirtualBox.",
        "⚡ Apprentissage des technologies de virtualisation  : création de machines virtuelles, déploiement d’infrastructures via VirtualBox,VMware etc..",
        "⚡ Initiation aux fondamentaux des télécommunications : modulation, multiplexage, transmission de signaux, architecture des réseaux mobiles (4G/5G), et compréhension des systèmes de communication modernes."
    
      ],
      website_link: "https://iut.univ-reunion.fr/",
    },
    {
      title: "BAC Sciences et Technologies de l'Industrie et du Développement Durable parcours Systèmes d’Information et Numérique",
      subtitle: "Lycée de Bois D'olives",
      logo_path: "Bois_Olive_rond.png",
      alt_name: "Lycée de Bois D'olives",
      duration: "2019 - 2022",
      descriptions: [
        "⚡ Étude des systèmes numériques : programmation embarquée, électronique, traitement du signal et communication de données.",
    "⚡ Réalisation de projets techniques autour des objets connectés (IoT), des microcontrôleurs (Arduino, Raspberry Pi) et du développement web (HTML/CSS/JavaScript).",
    "⚡ Mise en œuvre de protocoles de communication réseau, modélisation de systèmes intelligents et initiation à la cybersécurité.",
    "⚡ Participation à des projets multimédias tels que la création de vidéos documentaires, de sites web et d’applications mobiles.",
      ],
      website_link: "https://etab.ac-reunion.fr/lyc-bois-d-olive/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Attestation PIX",
      subtitle: "- PIX",
      logo_path: "Pix_fond.png",
      //certificate_link: "",
      alt_name: "PIX",
      color_code: "#0C9D5899",
    },
    {
      title: "MOOC de l'ANSSI",
      subtitle: "- ANSSI",
      logo_path: "anssi_fond.png",
      certificate_link:
        "/Attestation_MOOC.pdf",
      alt_name: "ANSSI MOOC",
      color_code: "#8C151599",
    },

   
    // {
    //   title: "Advanced ML on GCP",
    //   subtitle: "- GCP Training",
    //   logo_path: "google_logo.png",
    // //certificate_link:"https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
    //   alt_name: "Google",
    //   color_code: "#0C9D5899",
    // },
    



   
  ],
};

// Experience Page
const experience = {
  title: "Expériences",
  subtitle: "Stages, Emplois et Projets",
  description:
    "Passionné par les infrastructures réseaux et la cybersécurité, j'ai forgé mon expertise à la croisée des défis académiques et de la réalité du terrain. De mes projets techniques à mon alternance chez SFR Business, j'ai développé une réactivité concrète face aux enjeux critiques du numérique. Mon objectif : transformer la complexité technologique en solutions performantes, résilientes et sécurisées",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Stages",
      work: true,
      experiences: [
        {
          title: "Stagiaire en Cybersécurité",
          company: "Reverse OI",
          company_url: "https://www.reverse-oi.com/",
          logo_path: "reverse_oi_logo.png",
          duration: "Avril 2025 - Juillet 2025",
          location: "Le Port, La Réunion",
          description:
            "Participation à des missions d'évaluation des risques en sécurité informatique, notamment des tests d'intrusion (pentesting) et de la surveillance des systèmes d'information. Contribution au développement de solutions personnalisées pour les clients.",
          color: "#FF6C37",
        },
        {
          title: "Stagiaire Réseaux et Cybersécurité",
          company: "Xtronique Micro Sud",
          company_url: "#",
          logo_path: "network_logo.png",
          duration: "Avril 2024 - Juin 2024",
          location: "La Réunion",
          description:
            "Intégration de nouvelles technologies (Switch Aruba, Routeur Synology, Access Point Aruba), analyse et optimisation d'infrastructure réseau, configuration de dispositifs de sécurité, rédaction de documentation technique et présentation finale.",
          color: "#004aad",
        },
        
        {
          title: "Stagiaire Aide de Cuisine",
          company: "Restaurant Le Belem",
          company_url: "#",
          logo_path: "restaurant_logo.png",
          duration: "2019",
          location: "La Réunion",
          description:
            "Stage de découverte dans la restauration : aide en cuisine, polyvalence, esprit d'équipe et gestion de tâches sous pression.",
          color: "#a0522d",
        },
      ],
    },
    {
      title: "Emplois",
      experiences: [

       {
  title: "Alternant Technicien Support Client",
  company: "SFR Business",
  company_url: "#",
  logo_path: "sfr.png",
  duration: "2025-2026",
  location: "La Réunion",
  description: [
  "• Mise en service d'accès internet (FTTH, FTTO, SDSL/4G/5G...).",
  "• Configuration d'équipements clients (Routeurs, Switchs).",
  "• Administration CentreX et Trunk SIP.",
  "• Paramétrage communication unifiée.",
  "• Support technique N1, N2 et N3.",
  "• Gestion Ticketing ITSM et respect des SLA.",
  "• Monitoring proactif des infrastructures.",
  "• Rédaction de documentations techniques."
],
color: "#3b3b3b",
  color: "#3b3b3b",
  color: "#3b3b3b",
},
        {
          title: "Intérimaire",
          company: "Axion",
          company_url: "#",
          logo_path: "axion_logo.png",
          duration: "2023",
          location: "La Réunion",
          description:
            "Missions variées en intérim, développement de la rigueur professionnelle, sens du travail d’équipe et adaptation rapide à différents postes.",
          color: "#3b3b3b",
        },
        {
          title: "Caissier",
          company: "E.Leclerc",
          company_url: "https://www.e-leclerc.re/",
          logo_path: "leclerc_logo.png",
          duration: "Juillet 2023 - Août 2023",
          location: "Saint-Pierre, La Réunion",
          description:
            "Accueil des clients, gestion des transactions en caisse, assistance et orientation des clients dans le magasin. Développement des compétences en service client et gestion des opérations de caisse.",
          color: "#0056A8",
        },
      ],
    },
    {
      title: "Projets et Concours",
      experiences: [
        {
          title: "Participant au concours Ideakaton",
          company: "IUT de Saint-Pierre",
          company_url: "#",
          logo_path: "competition_logo.png",
          duration: "2022",
          location: "Saint-Pierre, La Réunion",
          description:
            "Participation à un concours d’innovation. Réalisation d’un inventaire intelligent dans le cadre d’un projet de cybersécurité. Résultat : 2ème place régionale.",
          color: "#7c4dff",
        },
      ],
    },
  ],
};


// Projects Page
const projectsHeader = {
  title: "Projets",
  description: "Mes projets couvrent un large éventail de domaines allant des infrastructures réseau sécurisées à la cybersécurité offensive et défensive. J’ai particulièrement apprécié concevoir et déployer des architectures réseau multi-sites, réaliser des audits de sécurité, mettre en place des services critiques (DNS, AD, VPN), et développer des outils interactifs.Chaque projet m’a permis de renforcer mes compétences techniques tout en appliquant des solutions concrètes sur des environnements simulés ou réels. J’accorde une attention particulière à la sécurité, à la performance, et à la documentation rigoureuse de mes réalisations.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    // {
    //   id: "neuro-symbolic-sudoku-solver",
    //   name: "Neuro-Symbolic Sudoku Solver",
    //   createdAt: "2023-07-02T00:00:00Z",
    //   description: "Paper published in KDD KiML 2023",
    //   url: "https://arxiv.org/abs/2307.00653",
    // },
    // {
    //   id: "mdp-diffusion",
    //   name: "MDP-Diffusion",
    //   createdAt: "2023-09-19T00:00:00Z",
    //   description: "Blog published in Paperspace",
    //   url: "https://blog.paperspace.com/mdp-diffusion/",
    // },
    // {
    //   id: "consistency-models",
    //   name: "Consistency Models",
    //   createdAt: "2023-10-12T00:00:00Z",
    //   description: "Blog published in Paperspace",
    //   url: "https://blog.paperspace.com/consistency-models/",
    // },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contactez Moi !",
    profile_image_path: "moi.jpg",
    description:
"Je suis disponible sur tous les réseaux sociaux ci-dessous ! Je réponds généralement en moins de 24 heures.",  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "J'adore docuementer mes projets dans un blog. Vous pouvez le consulter ici.",
    //link: "https://blogs.ashutoshhathidara.com/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Adresse",
    subtitle: "Hubert Delisle, Saint Pierre, Ile de La Réunion",
    locality: "San Jose",
    country: "USA",
    region: "California",
    postalCode: "95129",
    streetAddress: "Saratoga Avenue",
    avatar_image_path: "address_image.svg",
    // location_map_link: "https://maps.app.goo.gl/NvYZqa34Wye4tpS17",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};


